import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { ApplicationHttpClient } from '@app/core/http';



@Injectable({ providedIn: 'root' })
export class LicenseService {

  constructor(private http: ApplicationHttpClient) {
  }

  public getDetailById(id: string) {
    return this.http.get(`/api/app/license/status-license/${ id }`).pipe(
      map(detail => {
        return detail;
      })
    );
  }

  public getCurrent(){
    return this.http.get(`/api/app/license/current`).pipe(
        map(detail => {
          return detail;
        })
      );
  }
}
